module.exports = __webpack_public_path__ + "img/vipay_logo.a9663580.png";